// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../assets/theme/css/dashboard.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 charts per row */
  gap: 20px; /* spacing between charts */
}

.chart-wrapper {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.chart-wrapper canvas {
  width: 100% !important;
  height: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/common-dashboards/partnerWiseChart/partnerWiseChart.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,qCAAA,EAAA,qBAAA;EACA,SAAA,EAAA,2BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;AAAF;;AAGA;EACE,sBAAA;EACA,uBAAA;AAAF","sourcesContent":["@import '../../../../assets/theme/css/dashboard.css';\n\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* 2 charts per row */\n  gap: 20px; /* spacing between charts */\n}\n\n.chart-wrapper {\n  background: #fff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.chart-wrapper canvas {\n  width: 100% !important;\n  height: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
